import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '../../Buttons/IconButton';
import ArrowLeft from '../../Icons/16x16/ArrowLeft';
import Close16 from '../../Icons/16x16/Close';
import PopoverHeadingText from '../PopoverHeadingText';
import SpreadLayout from '../SpreadLayout';
import s from './PopoverHeader.scss';
/** A wrapper around left-side items to help keep the main component body clean */ const LeftItem = ({ children })=>/*#__PURE__*/ React.createElement("div", {
        className: s['left-item-wrapper']
    }, children);
/** Our standard Popover header. */ const PopoverHeader = ({ heading, subheading, illustration, onBackClick, onCloseClick, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(SpreadLayout, {
        className: className,
        left: [
            onBackClick && /*#__PURE__*/ React.createElement(LeftItem, {
                key: "back-button"
            }, /*#__PURE__*/ React.createElement(IconButton, {
                key: "back-button",
                icon: ArrowLeft,
                size: "small",
                onClick: onBackClick,
                "aria-label": t('common.back')
            })),
            illustration && /*#__PURE__*/ React.createElement(LeftItem, {
                key: "illustration"
            }, illustration),
            /*#__PURE__*/ React.createElement(LeftItem, {
                key: "heading"
            }, /*#__PURE__*/ React.createElement(PopoverHeadingText, null, heading), subheading && /*#__PURE__*/ React.createElement(PopoverHeadingText, {
                isSubheading: true
            }, subheading))
        ],
        right: onCloseClick && /*#__PURE__*/ React.createElement(IconButton, {
            icon: Close16,
            "aria-label": t('common.close'),
            size: "medium",
            onClick: onCloseClick
        })
    });
};
PopoverHeader.displayName = 'PopoverHeader';
export default PopoverHeader;

//# sourceMappingURL=PopoverHeader.js.map